import { ADMIN_USERS_ENDPOINTS, AdminUsersService } from "@/service/api/admin-users";
import { FilterItem } from "@/modules/common/filters";
import useOptionsQuery from "./useOptionsQuery";

const useAdminUsersOptions = (currentValue?: FilterItem) => {
  const result = useOptionsQuery(
    [ADMIN_USERS_ENDPOINTS.GET_USERS],
    (page, search) => AdminUsersService.getUsers({ page, search }),
    (page) => page.values.map((user) => ({ value: user.id, label: user.name })),
    (lastPage) => (lastPage.metadata.currentPage < lastPage.metadata.totalPages ? lastPage.metadata.currentPage + 1 : undefined),
    "Erro ao carregar administradores.",
    currentValue,
  );

  const users = result.pages.flatMap((page) => page.values);

  return { ...result, users };
};

export default useAdminUsersOptions;
